var map = {
	"./ADA-icon.svg": "e5b4",
	"./Apex-logo.svg": "757f",
	"./BNB-icon.svg": "afd9",
	"./BTC-icon.svg": "7545",
	"./BUSD-icon.svg": "34cc",
	"./DOT-icon.svg": "c607",
	"./ETH-icon.svg": "a3c8",
	"./FDUSD-icon.svg": "640a",
	"./LVL-icon.svg": "8c63",
	"./LiSA-logo.svg": "0243",
	"./LoT-logo.svg": "ffae",
	"./SOL-icon.svg": "2dc4",
	"./TUSD-icon.svg": "b12c",
	"./USDC-icon.svg": "8760",
	"./USDT-icon.svg": "c4e1",
	"./WL-logo.svg": "fce6",
	"./XRP-icon.svg": "1214",
	"./api-key-buddy.svg": "f46d",
	"./arrow-left.svg": "51b5",
	"./bidsLong.svg": "a774",
	"./bidsShort.svg": "23cb",
	"./bidsStopLoss.svg": "0a13",
	"./bidsTakeProfit.svg": "0b7b",
	"./calendar.svg": "287df",
	"./checked-outlined.svg": "bb5c",
	"./checked.svg": "1f78",
	"./chevron-down.svg": "ee76",
	"./chevron-left.svg": "7fc6",
	"./chevronDownMed.svg": "cf1a",
	"./close-chip.svg": "9485",
	"./close-positions.svg": "3730",
	"./close.svg": "864a",
	"./cog.svg": "8557",
	"./copy.svg": "c0a5",
	"./direction-arrow-long.svg": "bea8",
	"./drag.svg": "a2f6",
	"./edit.svg": "2fb0",
	"./eraser.svg": "9a04",
	"./error.svg": "7518",
	"./expand-menu.svg": "3766",
	"./eye-no.svg": "2424",
	"./eye.svg": "57fa",
	"./hint-2fa.svg": "fa98",
	"./hint-account.svg": "02d7",
	"./hint-key.svg": "1988",
	"./hint-kyc.svg": "0f7a",
	"./icon-windows.svg": "a169",
	"./info-filled.svg": "ede8",
	"./info.svg": "b888",
	"./info2.svg": "0016",
	"./leverages-marker.svg": "8f92",
	"./link.svg": "5fda",
	"./list-item-marker.svg": "5228",
	"./lock-icon.svg": "8cb1",
	"./lock.svg": "a012",
	"./long-icon.svg": "1bca",
	"./loupe.svg": "8ba4",
	"./placeholder-logo.svg": "71a5",
	"./preloader-track.svg": "ca17",
	"./question.svg": "5d9e",
	"./resize-tables-icon.svg": "82f5",
	"./robot-outline-active.svg": "623b",
	"./robot-outline.svg": "f729",
	"./short-icon.svg": "f6f8",
	"./star.svg": "4e5a",
	"./success.svg": "ce70",
	"./toggle.svg": "ed26",
	"./transfer-created.svg": "c97b",
	"./transfer-error.svg": "686f",
	"./transfer-progress.svg": "f0fd",
	"./transfer-success.svg": "251c",
	"./warning-gray.svg": "18bb",
	"./warning-icon.svg": "e848",
	"./win-close.svg": "93cd",
	"./win-fullscreen.svg": "fa9a",
	"./win-minimize.svg": "3cda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a601";